var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"footer-bottom"},[(_vm.$store.state.appUserInstance)?_c('v-col',{staticClass:"col-12 col-md-3 menu-col"},[_c('menu-container')],1):_vm._e(),(_vm.isEditingMenu)?_c('div',{staticClass:"blocker"}):_vm._e(),_c('v-col',{staticClass:"col-12 col-md-9"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }